import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Account} from '../../shared/model/account/account.model';
import {CreateAccountPayload} from './payload/createAccountPayload.model';
import {Page} from '../../shared/model/core/page.model';
import {Pageable} from '../../shared/model/core/pageable.model';
import {Operator, Order, Sort, UrlBuilder} from '../../shared/utils/url.builder';
import {Observable} from 'rxjs';
import {AccountSummary} from '../../shared/model/account/accountSummary.model';


@Injectable({
    providedIn: 'root'
})
export class AccountService {

    private static readonly ROOT_PATH = environment.webserviceUrl + '/v1/accounts';

    constructor(private httpClient: HttpClient) { }

    find(pageable: Pageable): Promise<Page<Account>> {
        const url: string = new UrlBuilder(AccountService.ROOT_PATH)
            .withPagination(pageable)
            .addParameter('active', 'true', Operator.EQUALS)
            .withOrder(new Sort('name', Order.ASCENDING))
            .build();
        return this.httpClient
            .get<Page<Account>>(url)
            .toPromise();
    }

    findOneById(id: number): Observable<Account> {
        return this.httpClient
            .get<Account>(AccountService.ROOT_PATH + '/' + id);
    }

    findOneByBusinessCode(businessCode: string): Observable<Account> {
        return this.httpClient
            .get<Account>(AccountService.ROOT_PATH + '/by-businessCode/'  + businessCode);
    }

    findOneSummaryByBusinessCode(businessCode: string): Observable<AccountSummary> {
        return this.httpClient
            .get<AccountSummary>(AccountService.ROOT_PATH + '/by-businessCode/'  + businessCode + '/summary');
    }

    getCurrent(): Observable<Account> {
        const url = AccountService.ROOT_PATH + '/mine';
        return this.httpClient
            .get<Account>(url);
    }

    create(payload: CreateAccountPayload): Promise<Account> {
        return this.httpClient
            .post<Account>(AccountService.ROOT_PATH, payload)
            .toPromise();
    }
}
